import React, { useEffect, useRef, useState } from 'react';
import './optionsPhoto.style.scss';
import { SLPOptionButtonType, OptionItemType } from 'utilities/slp/options/options.index';
import { __OptionPhotoProps, __OptionPhotoRef } from './optionsPhoto.interface';
import SLPInput from 'utilities/slp/input/input.index';
import cover from 'assets/images/backgrounds/card-cover.jpg';
import { ImageSize } from 'interface';
import { TextDirection } from 'interface';
import HintText from '../hintText/hintText.index';
import QuestionImage from '../questionImage/questionImage.index';
import { extractTitle } from 'scripts/string';
export interface SLPOptionPhotoRef extends __OptionPhotoRef {}

const SLPOptionsPhoto: React.ForwardRefRenderFunction<__OptionPhotoRef, __OptionPhotoProps> = (
    props: __OptionPhotoProps,
    ref,
) => {
    const [value, setValue] = useState<OptionItemType[]>(props.defaultValue ? props.defaultValue : []);
    const immediateValue = useRef<OptionItemType[]>(value);
    const [error, setError] = useState<string>();
    // const [textValue, setTextValue] = useState<string>();
    const index = value.findIndex((item) => Number(item.value) === 1);
    const labelRef = useRef<HTMLLabelElement>(null);

    useEffect(() => setError(undefined), [value]);

    React.useImperativeHandle(ref, () => ({
        getValue: () => immediateValue.current,
        setError: (text) => {
            setError(text);
        },
    }));

    useEffect(() => {
        if (labelRef.current && props.label) labelRef.current.innerHTML = extractTitle(props.label, false);
    }, [props.label]);

    const changeHandler = (e: OptionItemType[]) => {
        setError(undefined);
        immediateValue.current = e;
        setValue(immediateValue.current);
        if (props.onChange) props.onChange(e);
    };

    function onSelectItem(item: OptionItemType) {
        if (!props.multiSelect) {
            value.length > 0 && value[0].payload === item.payload ? changeHandler([]) : changeHandler([item]);
        } else {
            let temp = [...value];
            value.map((i) => i.payload).includes(item.payload)
                ? (temp = temp.filter((x) => x.payload !== item.payload))
                : temp.push(item);
            changeHandler(temp);
        }
    }

    return (
        <div
            className={`u-check-SLP-option-photo  ${props.dir === TextDirection.rtl ? 'rtl-text' : ''} ${
                props.vertical ? 'vertical' : ''
            } `}
        >
            <div className="header-title" style={{ color: props.labelColor }}>
                {props.required && <span className="required-star">*</span>}
                <span className="counter-span">{props.counter ? props.counter + '- ' : ''}</span>
                <label ref={labelRef} style={{ color: props.labelColor }} />
            </div>
            <QuestionImage src={props.image?.file} />
            <HintText value={props.hint} />
            <div className="cards-container">
                {props.items.map((item, index) =>
                    !item.archive && !item.isHidden ? (
                        <label
                            key={index}
                            className={`${value.map((i) => i.payload).includes(item.payload) ? 'active' : ''} ${
                                props.buttonStyle !== SLPOptionButtonType.radio ? ' checkbox' : ' radio'
                            } ${
                                props.imageSize === ImageSize.small
                                    ? 'small'
                                    : props.imageSize === ImageSize.medium
                                    ? 'medium'
                                    : ''
                            }`}
                            onClick={() => onSelectItem(item)}
                            style={{
                                color: props.color,
                                border: value.includes(item) ? `${props.color + ' 1px solid'}` : '',
                            }}
                        >
                            <div className="checkbox-cover">
                                <img src={item.image ? item.image.file : cover} alt="multi option photo" />
                            </div>
                            <div className="multiSelect-footer">
                                <p dangerouslySetInnerHTML={{ __html: item.title }}></p>
                                <div
                                    className="circle"
                                    style={{
                                        background: value.includes(item) ? props.color : '',
                                        border: value.includes(item) ? `${props.color + ' 1px solid'}` : '',
                                    }}
                                />
                            </div>
                        </label>
                    ) : null,
                )}
                {Array.from(Array(7).keys()).map((item, index) => (
                    <label
                        key={index}
                        className={`pt-0 pb-0 mb-0 mt-0 spacer u-check-option-photo d-none ${
                            props.vertical ? '' : ' d-flex '
                        } ${
                            props.imageSize === ImageSize.small
                                ? 'small'
                                : props.imageSize === ImageSize.medium
                                ? 'medium'
                                : ''
                        }`}
                    />
                ))}
                {index !== undefined && index > -1 && (
                    <SLPInput
                        onEnter={props.next}
                        onChange={(e) => {
                            if (props.onTextChange) props.onTextChange(e);
                        }}
                    />
                )}
            </div>
            {error && <p className="option-photo-error">{error}</p>}
        </div>
    );
};

export default React.forwardRef(SLPOptionsPhoto);
